import { Component } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-community',
  template: `
    <app-bar flTrackingSection="SubnavCommunity">
      <app-bar-item
        link="/community"
        i18n="Secondary navigation community bar item"
        flTrackingLabel="Community"
        [exactLink]="true"
      >
        Community
      </app-bar-item>
      <app-bar-item
        link="/community/experts"
        i18n="Secondary navigation community bar item"
        flTrackingLabel="Experts"
        [exactLink]="true"
      >
        Experts
      </app-bar-item>
      <app-bar-item
        link="/showcase"
        i18n="Secondary navigation community bar item"
        flTrackingLabel="Showcase"
        [exactLink]="true"
      >
        Showcase
      </app-bar-item>
      <app-bar-item
        link="/community/my-articles"
        i18n="Secondary navigation community bar item"
        flTrackingLabel="MyPosts"
        [exactLink]="true"
      >
        My Posts
      </app-bar-item>
    </app-bar>
  `,
})
export class NavigationSecondaryCommunityComponent {
  ButtonColor = ButtonColor;
}
